module.exports = __webpack_public_path__ + "static/media/scroll3_3.b69a48d3.png";